import ENV from "config/Env";
import { backendQueryKey } from "hooks";

import type { ReportTemplate } from "models";

const component = "ReportTemplatesDashboard";

export const ReportTemplatesDashboardQueryKeys = {
  list: backendQueryKey<ReportTemplate[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/report_templates/list" })
};
